import React from 'react';
import styled from 'styled-components';

export interface PillarNumberBadgeProps {
  number: string;
  pillarType: string;
  className?: string;
}

const COLORS = {
  communitiesColor: '#0077a0',
  servicesColor: '#C92E5A',
  neighborhoodsColor: '#116A3C',
  policyColor: '#CC4712',
  colortextlightsolid: '#fff',
};

const getPillarColor = (pillarType: string) => {
  switch (pillarType) {
    case 'Services':
      return COLORS.servicesColor;
    case 'Neighborhoods':
      return COLORS.neighborhoodsColor;
    case 'Policies':
      return COLORS.policyColor;
    case 'Communities':
    default:
      return COLORS.communitiesColor;
  }
};

const NumberWrapper = styled.div<{ pillarType: string }>`
  height: 35px;
  width: 35px;
  border-radius: 80px;
  background-color: ${props => getPillarColor(props.pillarType)};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-left: 8px;
  padding: 0;
  box-sizing: border-box;
  font-size: 20px;
  color: ${COLORS.colortextlightsolid};
`;

const NumberText = styled.div`
  position: relative;
  margin-left: 0;
  text-align: center;
  @media screen and (max-width: 450px) {
    font-size: 16px;
  }
`;

const NumberSpan = styled.span`
  font-weight: 500;
`;

const PillarNumberBadge: React.FC<PillarNumberBadgeProps> = ({
  number,
  pillarType,
  className,
}) => {
  return (
    <NumberWrapper pillarType={pillarType} className={className}>
      <NumberText>
        <NumberSpan>#{number}</NumberSpan>
      </NumberText>
    </NumberWrapper>
  );
};

export default PillarNumberBadge;
